<template>
  <div class="row login-normal-container mfa-text">
    <div class="col-lg-6 col-md-6 flex justify-center pb-4">
      <PasswordSuccess
        v-if="passSuccess"
        @backToLogin="backToLogin"
      ></PasswordSuccess>
      <PasswordExpired
        v-else
        @backToLogin="backToLogin"
        @passSuccess="passChangeSuccess"
        :lastPassword="lastPassword"
        class="w-3/4 xl:w-1/2"
      />
    </div>
    <div
      id="imageBackground"
      class="col-lg-6 col-md-6 flex justify-center flex-col items-center"
    >
      <div
        class="mobile-hide desktop-show-titles text-zt-primary-200 text-center text-2xl mb-5"
      >
        {{ $t("message.login_welcome_title") }}
      </div>
      <div v-if="$browserDetect.isChrome" class="logo-desktop"></div>
      <div v-else>
        <img
          :src="`${baseUrl}assets/images/background-login.png`"
          class="logo-desktop-noChrome"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PasswordExpired from "@/components/login/passwordExpired/PasswordExpired";
import PasswordSuccess from "@/components/login/passwordExpired/PasswordSuccess";

export default {
  name: "PasswordExpiredTemplate",
  props: {
    lastPassword: {
      type: String,
      default: "",
    },
  },
  components: {
    PasswordExpired,
    PasswordSuccess,
  },
  data() {
    return {
      passSuccess: false,
    };
  },
  methods: {
    backToLogin() {
      this.$emit("backToLogin");
    },
    passChangeSuccess() {
      this.passSuccess = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./passwordexpiredtemplate.scss";
</style>
